<template>
    <div class="area-menu">
        <router-link v-for="item in visibleItems"
                     :key="item.context"
                     :to="'/' + item.context"
                     class="area-menu-item"
                     :class="{ 'router-link-active': $route.path.match(new RegExp('/' + item.context + '(/|$)', 'i')) }">
            <div class="area-menu-item-icon material-symbols-outlined">{{ item.icon }}</div>
            <div class="area-menu-item-label">{{ item.label }}</div>
        </router-link>

        <a v-if="!loaded" class="area-menu-item">
            <div class="area-menu-item-icon material-symbols-outlined">pending</div>
            <div class="area-menu-item-label">Lädt</div>
        </a>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    const items = [
        {
            icon: 'architecture',
            label: 'Projekte',
            context: 'Projects'
        },
        {
            icon: 'contact_page',
            label: 'Stammdaten',
            context: 'MainData/Organizations'
        },
        {
            icon: 'engineering',
            label: 'Admin',
            context: 'Admin'
        },
        {
            icon: 'map',
            label: 'Karte',
            context: 'Map'
        }
    ];

    export default defineComponent({
        data() {
            return {
                items: [],
                context: null,
                loaded: false
            };
        },
        computed: {
            canReadAnyProjects() {
                return meApi.hasAnyPermissionSync([
                    AppPermissions.ProjectsOverview.Read,                 
                ]);
            },
            canReadAdmin() {
                return meApi.hasAnyPermissionSync([
                    AppPermissions.AdminUsers.Read,
                    AppPermissions.AdminRoles.Read,
                    AppPermissions.AdminPermissionDefinitions.Read,
                    AppPermissions.AdminTemplates?.Read,
                    AppPermissions.AdminLists?.Read,
                    AppPermissions.AdminTenants?.Read
                ].filter(Boolean));
            },
            visibleItems() {
                return this.items.filter(item => {
                    if (item.context === 'Projects')
                        return this.canReadAnyProjects;

                    if (item.context === 'MainData/Organizations')
                        return meApi.hasPermissionSync(AppPermissions.MasterData.Read);

                    if (item.context === 'Admin')
                        return this.canReadAdmin;

                    if (item.context === 'Map')
                        return meApi.hasPermissionSync(AppPermissions.Map.Read);

                    return true;
                });
            }
        },
        async created() {
            await meApi.ensurePermissionsLoaded();

            this.items = items;
            this.loaded = true;

            if (this.context === null && this.visibleItems.length > 0)
                this.context = this.visibleItems[0];
        },
        methods: {
            changeContext(context) {
                this.context = context
            }
        }
    });
</script>

<style>
    .area-menu {
        background: var(--color-background-light);
        color: var(--color-text);
        margin: 6px;
        border-radius: 4px;
    }

    .area-menu-item {
        margin: 5px;
        border-radius: 3px;
        color: inherit;
        margin-bottom: 18px;
        text-decoration: none;
        display: block;
    }

    .area-menu-item-icon {
        transition: all 0.3s ease-in-out;
        padding: 5px;
        background: var(--color-background);
        font-size: 50px;
        border-radius: 2px;
    }

        .area-menu-item-icon:hover {
            background: var(--color-background-lighter);
        }

    .router-link-active .area-menu-item-icon {
        background: var(--color-accent);
    }

    .area-menu-item-label {
        margin: 3px 5px;
        text-align: left;
        font-size: 0.5rem;
    }
</style>